/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

// globals FB, util

import $ from "jquery";
import OkC from "shared/util/OkcApi";
import Context from "shared/util/Context";

window.OkFB = {
	js: "//connect.facebook.com/en_US/sdk.js",
	scope: "email,user_birthday,user_photos,user_friends",

	initialized: false,
	initializing: false,
	connected: undefined,
	permissions: {},
	init_waiters: [],

	init(cb) {
		if (this.initialized) {
			if (cb) {
				cb();
			}
			return;
		}
		if (cb) {
			this.init_waiters.push(cb);
		}
		if (this.initializing) {
			return;
		}
		this.initializing = true;

		$("body").append($('<div id="fb-root">'));

		// $.getScript doesn't allow for caching
		return $.ajax({
			url: this.js,
			dataType: "script",
			cache: true,

			complete: response => {
				return this.init_cb(response);
			},
		});
	},

	init_cb(response) {
		if (typeof FB === "undefined" || FB === null) {
			window.util.updateStats(
				"OkFB - Facebook JS load - fail",
				1,
				"counter",
				"oxSUj7eqnZ9LUZXeGXHAxH8tpZs="
			);
			return;
		}
		FB.init(this.getConfig());

		// use FB.getLoginStatus to make sure FB
		// has been initted before running waiters
		return FB.getLoginStatus(() => {
			this.initialized = true;
			return this.init_waiters.map(waiter => waiter());
		});
	},

	getConfig() {
		return {
			appId: Context.get("fbAppId"),
			channelUrl: "/fb_channel",
			version: "v2.9",
		};
	},

	havePermission(permission) {
		return permission in this.permissions;
	},

	havePermissions(permissions) {
		for (let permission of permissions) {
			if (!this.havePermission(permission)) {
				return false;
			}
		}
		return true;
	},

	onConnect(connect_new, fb_res, cb) {
		if (!fb_res || fb_res.status !== "connected") {
			this.connected = false;
			fb_res.isConnected = this.connected;
			cb(fb_res);
			return;
		}

		let params = { token: fb_res.authResponse.accessToken };

		if (connect_new) {
			params.connect_new = "1";
		}

		OkC.post(
			"/social/fb/connect",
			{
				data: params,

				success: connect_res => {
					this.connected = false;
					switch (connect_res && connect_res.status) {
						case "ok":
							this.connected = true;
							break;
						case "wrong_user":
							alert(
								"Sorry! This Facebook account is connected " +
									"to a different OkCupid profile. You can\u2019t " +
									"use it with this profile at the same time."
							);
							break;
						case "wrong_fb_user":
							alert(
								"This OkCupid profile is connected to a " +
									"different Facebook account. "
							);
							break;
					}
					fb_res.isConnected = this.connected;
					return cb(fb_res);
				},
			},
		);
	},

	checkConnected(cb) {
		if (this.connected !== undefined) {
			cb({ isConnected: this.connected });
			return;
		}

		OkC.get(
			"/social/fb/status",
			{
				success: res => {
					this.permissions = res.permissions || {};
					if (res && res.status === "ok") {
						this.connected = true;
						cb({ isConnected: this.connected });
						return;
					}
					if (res && res.status === "not_connected") {
						this.connected = false;
						cb({ isConnected: this.connected });
						return;
					}

					if (typeof FB !== "undefined" && FB !== null) {
						return FB.getLoginStatus(fb_res => this.onConnect(false, fb_res, cb));
					} else {
						return cb({ isConnected: this.connected });
					}
				},
			},
		);
	},

	ifConnected(cb) {
		return this.checkConnected(() => {
			if (this.connected) {
				return cb({ isConnected: this.connected });
			}
		});
	},

	connect(scope, cb) {
		if (typeof scope === "function") {
			cb = scope;
			({ scope } = this);
		}
		if (this.connected && this.havePermissions(scope.split(","))) {
			if (cb) {
				cb({ connected: true });
			}
			return;
		}
		if (typeof FB !== "undefined" && FB !== null) {
			return FB.login(
				fb_res => {
					return this.onConnect(true, fb_res, cb);
				},
				{ scope, auth_type: "rerequest" }
			);
		} else {
			return cb();
		}
	},

	api(path, params, cb) {
		if (typeof params === "function") {
			cb = params;
			params = {};
		}

		return OkC.post(
			"/social/fb",
			{
				data: {
					path,
					params,
				},

				success: d => cb(d),
			},
		);
	},
};



// WEBPACK FOOTER //
// ./src/legacy/okfb.js